// extracted by mini-css-extract-plugin
module.exports = {"box":"box-NrRVIrv4"};